'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RejoinRoute = undefined;

var _runOnEnter = require('routes/helpers/runOnEnter');

var _runOnEnter2 = _interopRequireDefault(_runOnEnter);

var _requireLoggedIn = require('routes/helpers/requireLoggedIn');

var _requireLoggedIn2 = _interopRequireDefault(_requireLoggedIn);

var _requireMembershipStatus = require('routes/helpers/requireMembershipStatus');

var _requireMembershipStatus2 = _interopRequireDefault(_requireMembershipStatus);

var _memberStatus = require('enums/memberStatus');

var _Rejoin = require('./Rejoin.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

var RejoinRoute = exports.RejoinRoute = function RejoinRoute(store, client) {
  var requireLoggedIn = function requireLoggedIn(nextState, replaceState, cb) {
    return store.runSagaOnce(_requireLoggedIn2.default, nextState, replaceState).done.then(cb, cb);
  };

  var requireChurned = function requireChurned(nextState, replaceState, cb) {
    return store.runSagaOnce(_requireMembershipStatus2.default, client, replaceState, [(0, _memberStatus.memberStatus)('CANCELLED')]).done.then(cb, cb);
  };

  var requireEligible = function requireEligible(nextState, replaceState, cb) {
    return store.runSagaOnce(_Rejoin.checkWinbackOfferPermissionSaga, client, replaceState, null, '/rejoin/welcome-back').done.then(cb, cb);
  };

  var requireIneligible = function requireIneligible(nextState, replaceState, cb) {
    return store.runSagaOnce(_Rejoin.checkWinbackOfferPermissionSaga, client, replaceState, '/rejoin', null).done.then(cb, cb);
  };

  return {
    path: 'rejoin',

    onEnter: requireChurned,
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          // only allow
          // - logged in + churned + eligible
          component: require('containers/CmsPage/CmsPage').CmsPage,
          onEnter: (0, _runOnEnter2.default)(requireLoggedIn, requireEligible)
        });
      }, 'rejoin');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          // only allow
          // - logged in + churned + not eligible
          path: 'welcome-back',
          component: require('containers/CmsPage/CmsPage').CmsPage,
          onEnter: (0, _runOnEnter2.default)(requireLoggedIn, requireIneligible)
        }, {
          // allow
          // - non-logged in
          // - logged in + churned + eligible
          path: '*',
          component: require('containers/CmsPage/CmsPage').CmsPage,
          onEnter: requireEligible
        }]);
      }, 'rejoin');
    }
  };
};